import { useTranslation } from 'react-i18next';
import { MessageRotator } from '../../messageRotator/messageRotator.component';

export const Loading = () => {
  const { t } = useTranslation();
  const messages = [t('aiAssistant.loading'), t('aiAssistant.loading2'), t('aiAssistant.loading3')];

  return (
    <MessageRotator
      uniqueMessages={messages}
      sx={{ fontSize: '14px', color: 'rgba(244, 140, 7, 1)', fontWeight: 500 }}
    />
  );
};
